import React, { useState } from "react";
import { Typography, Button, Box } from "@mui/material";
import { FullScreenDialog } from "../../atoms/FullScreenDialog";
import { useHotkey } from "../../hotkeys/hooks";
import PatientNavDemo from "./PatientNavDemo";
import { useNavigate } from "react-router-dom";
import { PatientCommands } from "../../stores/Patients/patient.commands";
import useStore from "../../helpers/useStore";
import { PatientsContext } from "../../stores/Patients/patients.provider";
import { NavTablesContext } from "../../stores/NavTables";
import { observer } from "mobx-react";
import PatientTableDialog from "../../molecules/PatientRxTables/PatientTable";

const PatientNavigationPane: React.FC = observer(() => {
  // const [isDialogOpen, setIsDialogOpen] = useState(false);

  const navigate = useNavigate();
  const PatientStore = useStore(PatientsContext);
  const { navigateToPatient } = PatientCommands(PatientStore);

  

  const NavTablesStore = useStore(NavTablesContext);
  const {
    patientNavTableIsOpen,
    setPatientNavTableIsOpen,
  } = NavTablesStore;

  const handleCloseDialog = () => {
    setPatientNavTableIsOpen(false);
  };

  // update the selected row in the store, navigate to patient and close
  const handlePatientSelect = (patientId: number) => {
    navigateToPatient(navigate, patientId,null);
    handleCloseDialog();
  };

  return (
    <PatientTableDialog
      open={patientNavTableIsOpen}
      onClose={handleCloseDialog}
      onPatientSelect={handlePatientSelect}
    />
  );
});

export default PatientNavigationPane;
